<template>
    <tr class="shown demand-head" style="border-bottom:solid 1px lightgray;">
          <td colspan="2" class="v-align-middle head-element" v-if="demandType" >
            <span>{{demandType.attributes.display_name}}</span><br>
            <small v-if="demandType.attributes.hasOwnProperty('description')">
              {{demandType.attributes.description}}
            </small>
          </td>
          <td class="v-align-middle head-element">{{ demand.attributes.created_at | moment-date }}</td>
          <td class="v-align-middle head-element">
              <i v-if="demandStatus == 'validated'" style="color:green" class="fa fa-check-circle" aria-hidden="true"></i>
              <i v-if="demandStatus == 'pending'" style="color:grey" class="fa fa-circle" aria-hidden="true"></i>
              <i v-if="demandStatus == 'refused'" style="color:red" class="fa fa-times-circle" aria-hidden="true"></i>

              {{ getEnumTranslatedValue('validation_request_status', demandStatus) }}<br>
              <p v-if="demandStatus != 'pending' && demandTreatingUser" class="v-align-middle"> 
                <span>le {{ demand.attributes.treatment_date | moment-date }}</span><br>
                <span>par</span> <a :href="'mailto:'+ demandTreatingUser.attributes.email"> {{ demandTreatingUser.attributes.email}}</a>
              </p>
          </td>
          <td class="v-align-middle head-element">
            <p>{{ demandCustomer.attributes.name }}</p>
            <p v-if="demandCreatingUser"><a :href="'mailto:' + demandCreatingUser.attributes.email">{{ demandCreatingUser.attributes.email }}</a></p>
            <p v-else>Utilisateur supprimé</p>
          </td>
          <td class="v-align-middle head-element">
            <button 
              v-if="demandType.attributes.name != 'contract-option-creation' && demandType.attributes.name != 'contract-option-termination'"
              class="btn btn-default" 
              @click="$emit('show-details', {idx: index})" 
            >
              Détails
            </button>
            <router-link v-if="demandStatus === 'pending'"
              :to="{ name: 'single-demand', params: { id: demand.id } }"
            >
              <button class="btn btn-complete">Résoudre</button>
            </router-link>
          </td>
    </tr>
</template>

<script>
import {mapActions, mapState} from 'vuex'

export default {
  props:[
    "demand", 
    "index", 
    "details", 
    "full_list"
  ],

  data() {
    return {
      treatment_form:{}
    }
  },

  computed: {
      ...mapState('demands', ['forms']),

      retreiveTreatmentForm() {
        this.treatment_form = _.find(this.forms, (tf) => tf.main_request.request.id == this.demand.id)

        if (this.treatment_form) {
          return true
        }

        return false
      },

      demandStatus() {
        return this.demand.attributes.status
      },
      demandType() {
        return this.demand.included.hasOwnProperty('type') ? this.demand.included.type : null
      },
      demandCustomer() {
        return this.demand.included.hasOwnProperty('customer') ? this.demand.included.customer : null
      },
      demandCreatingUser() {
        return this.demand.included.hasOwnProperty('creating_user') ? this.demand.included.creating_user : null
      },
      demandTreatingUser() {
        return this.demand.included.hasOwnProperty('treating_user') ? this.demand.included.treating_user : null
      }
  },

  methods:{
    ...mapActions('demands', ['fetchCustomerInfo', 'validationRequestTreatmentForm']),

    hasDetailsEnabled() {
      return _.find(this.details, (dtls) => dtls.idx == this.index) ? true : false
    },

    init() {
      if (this.demandStatus === 'pending' && this.full_list) {
        this.validationRequestTreatmentForm(this.demand.id)
      }
    }
  },

  mounted() {
    this.init()
  }

}

</script>

<style lang="scss" scoped>
.small {
  font-size: 10px;
}

.demand-head {
  background-color: white;
}

.head-element {
  background-color: inherit;
}
</style>



// WEBPACK FOOTER //
// client/views/Demands/Demand.vue